import { createSelector } from "reselect";
import { RootState } from "../../store/rootReducer";
import { CurrentUserType, User } from "./types";
import {
  adminGroups,
  vpoRelationFactoryByGroups,
  vpoUsers,
  vpoUsersAdminRegion,
  vpoUsersAdmins,
  vpoUsersZone,
  vpoUsersEditNA,
  securityAdmins,
  securityEditors,
  directorsSupplay,
  gosAdmins,
  gosEditors,
  gosRelationFactoryByGroups,
  incidentsAdminGroups,
  AIAccess,
} from "./constants";
import { addAnalysis } from "../acadia/constants";
import { prefix } from "src/utils/users.utils";

const getUsers = (state: RootState) => state.users.items;
const getCurrentUser = (state: RootState) => state.users.current;

export type UserReturnType = {
  displayName: string;
  fullName: string;
  email: string;
  fullNameWithPatronymic: string;
  originalEmail: string;
  avatar: string;
  accountName: string;
  shortName: string;
  manager: string;
  persNumber: string;
  jobTitle: string;
  jobTitleStr: string;
  department: string;
  shortDisplayName: string;
};

export const selectUsers = createSelector([getUsers], (obj) => {
  let resultsObj: Record<string, Partial<UserReturnType> | null> = {};
  if (Object.keys(obj).length > 0) {
    Object.keys(obj).map((key) => {
      if (obj[key] && !Array.isArray(obj[key])) {
        let displayName =
          (obj[key]["UserProfileProperties"].length > 0 &&
            ((obj[key]["UserProfileProperties"].find((item: any) => item.Key === "PreferredNameRus") &&
              obj[key]["UserProfileProperties"].find((item: any) => item.Key === "PreferredNameRus")?.["Value"]) ||
              (obj[key]["UserProfileProperties"].find((item: any) => item.Key === "PreferredName") &&
                obj[key]["UserProfileProperties"].find((item: any) => item.Key === "PreferredName")?.["Value"]))) ||
          "";

        const fullNameWithPatronymic = displayName;
        let shortDisplayName = displayName;

        if (displayName.split(" ").length === 3) {
          displayName = `${displayName.split(" ")[0]} ${displayName.split(" ")[1]}`;
          shortDisplayName = `${displayName.split(" ")[0]} ${displayName.split(" ")[1][0]}.`;
        }
        let shortName = "";
        const nameArr = displayName.split(" ");
        if (nameArr.length > 0) {
          nameArr.map((item: string, idx: number) => {
            if (item && idx < 2) {
              shortName += item.trim()[0];
            }
          });
        }
        const persNumber =
          (obj[key]["UserProfileProperties"].length > 0 &&
            (obj[key]["UserProfileProperties"].find((item: any) => item.Key === "abiPersonnelNumber")?.["Value"] ||
              obj[key]["UserProfileProperties"].find((item: any) => item.Key === "UserName")?.["Value"])) ||
          "";
        const jobTitle =
          (obj[key]["UserProfileProperties"].length > 0 &&
            (obj[key]["UserProfileProperties"].find((item: any) => item.Key === "TitleRUS")?.["Value"] ||
              obj[key]["UserProfileProperties"].find((item: any) => item.Key === "SPS-JobTitle")?.["Value"])) ||
          "";
        const department =
          (obj[key]["UserProfileProperties"].length > 0 &&
            (obj[key]["UserProfileProperties"].find((item: any) => item.Key === "DepartmentRUS")?.["Value"] ||
              obj[key]["UserProfileProperties"].find((item: any) => item.Key === "Department")?.["Value"])) ||
          "";
        const managerAccount =
          (obj[key]["UserProfileProperties"].length > 0 &&
            obj[key]["UserProfileProperties"].find((item: any) => item.Key === "Manager")?.["Value"]) ||
          "";
        const managerEmail =
          (managerAccount.split("|").length > 0 &&
            managerAccount.split("|")[managerAccount.split("|").length - 1].toLowerCase()) ||
          "";
        resultsObj = {
          ...resultsObj,
          [key]: {
            displayName: `${displayName}${persNumber && " (" + persNumber + ")"}`,
            fullName: `${displayName}`,
            email: obj[key].AccountName.split("|")[obj[key].AccountName.split("|").length - 1].toLowerCase().trim(),
            originalEmail: obj[key].Email && obj[key].Email.toLowerCase().trim(),
            avatar: obj[key].PictureUrl,
            accountName: obj[key].AccountName,
            shortName: shortName,
            manager: managerEmail,
            persNumber: persNumber,
            jobTitle: `<span title="${jobTitle}">${(jobTitle.length > 20 && `${jobTitle.slice(0, 20)}...`) || `${jobTitle}`
              }</span>`,
            fullNameWithPatronymic: fullNameWithPatronymic,
            jobTitleStr: jobTitle,
            department: department,
            shortDisplayName: shortDisplayName
          },
        };
      } else {
        resultsObj = {
          ...resultsObj,
          [key]: null,
        };
      }
    });
  }
  // console.log('users: ', resultsObj);
  return resultsObj;
});

export const selectCurrentUser = createSelector([getCurrentUser], (obj: User) => {
  let displayName =
    (obj["UserProfileProperties"].length > 0 &&
      ((obj["UserProfileProperties"].find((item: any) => item.Key === "PreferredNameRus") &&
        obj["UserProfileProperties"].find((item: any) => item.Key === "PreferredNameRus")?.["Value"]) ||
        (obj["UserProfileProperties"].find((item: any) => item.Key === "PreferredName") &&
          obj["UserProfileProperties"].find((item: any) => item.Key === "PreferredName")?.["Value"]))) ||
    "";

  const fullNameWithPatronymic = displayName;

  if (displayName && displayName.split(" ").length === 3) {
    displayName = `${displayName.split(" ")[0]} ${displayName.split(" ")[1]}`;
  }
  let shortName = "";
  const nameArr = displayName.split(" ");
  if (nameArr.length > 0) {
    nameArr.map((item: string, idx: number) => {
      if (item && idx < 2) {
        shortName += item[0];
      }
    });
  }

  let infoVPO: any = {
    user: false,
    zone: false,
    admin: false,
    adminRegion: false,
    userEditNA: false,
    factory: [],
    directoryTitle: [],
  };

  let infoGOS: any = {
    editor: false,
    admin: false,
    factory: [],
    factoryIds: [],
    factoryTitles: [],
  };

  let isAdmin = false;
  let isSecurityAdmin = false;
  let isSecurityEditor = false;
  let isDirecor = false;
  let isPartner = false;
  let incidentAdmin = false;
  let AI = false;
  if (Object.keys(obj).length > 0) {
    obj.Groups.map((group: { Id: number }) => {
      if (adminGroups.some((item) => item === group.Id)) {
        isAdmin = true;
      }
      if (securityAdmins.some((item) => item === group.Id)) {
        isSecurityAdmin = true;
      }

      if (AIAccess.some((item) => item === group.Id) && obj.aiEnabled) {
        AI = true;
      }

      if (directorsSupplay.some((item) => item === group.Id)) {
        isDirecor = true;
      }
      if (securityEditors.some((item) => item === group.Id)) {
        isSecurityEditor = true;
      }
      if (incidentsAdminGroups.some((item) => item === group.Id)) {
        incidentAdmin = true;
      }

      // VPO Roles

      if (vpoUsers.some((item) => item === group.Id)) {
        infoVPO.user = true;
      }
      if (vpoUsersZone.some((item) => item === group.Id)) {
        infoVPO.zone = true;
      }
      if (vpoUsersAdmins.some((item) => item === group.Id)) {
        infoVPO.admin = true;
      }
      if (vpoUsersAdminRegion.some((item) => item === group.Id)) {
        infoVPO.adminRegion = true;
      }
      if (vpoUsersEditNA.some((item) => item === group.Id)) {
        infoVPO.userEditNA = true;
      }
      let filterFactoryByGroup = vpoRelationFactoryByGroups.filter((el) => el.groups.indexOf(group.Id) >= 0);
      if (filterFactoryByGroup && filterFactoryByGroup.length > 0) {
        filterFactoryByGroup.map((factory: any) => {
          infoVPO.factory.push({
            factoryID: factory.factoryID,
            factoryTitle: factory.factoryTitle,
          });

          infoVPO.directoryTitle.push(factory.directoryTitle);
        });
      }

      // GOS Roles

      if (gosEditors.some((item) => item === group.Id)) {
        infoGOS.editor = true;
      }
      if (gosAdmins.some((item) => item === group.Id)) {
        infoGOS.admin = true;
      }

      let filterFactoryByGroupGOS = gosRelationFactoryByGroups.filter((el) => el.groups.indexOf(group.Id) >= 0);
      if (filterFactoryByGroupGOS && filterFactoryByGroupGOS.length > 0) {
        filterFactoryByGroupGOS.map((factory: any) => {
          infoGOS.factoryIds.push(factory.factoryID);
          infoGOS.factoryTitles.push(factory.factoryTitle);
          infoGOS.factory.push({
            id: factory.factoryID,
            name: factory.factoryTitle,
          });
        });
      }
    });
  }

  const persNumber =
    (obj["UserProfileProperties"].length > 0 &&
      (obj["UserProfileProperties"].find((item: any) => item.Key === "abiPersonnelNumber")?.["Value"] ||
        obj["UserProfileProperties"].find((item: any) => item.Key === "UserName")?.["Value"])) ||
    "";
  const jobTitle =
    (obj["UserProfileProperties"].length > 0 &&
      (obj["UserProfileProperties"].find((item: any) => item.Key === "TitleRUS")?.["Value"] ||
        obj["UserProfileProperties"].find((item: any) => item.Key === "SPS-JobTitle")?.["Value"])) ||
    "";
  const department =
    (obj["UserProfileProperties"].length > 0 &&
      (obj["UserProfileProperties"].find((item: any) => item.Key === "DepartmentRUS")?.["Value"] ||
        obj["UserProfileProperties"].find((item: any) => item.Key === "Department")?.["Value"])) ||
    "";

  if (
    !isAdmin &&
    (obj.AccountName.split("|")
    [obj.AccountName.split("|").length - 1].toLowerCase()
      .trim()
      .indexOf("@partnerabie.com") !== -1 ||
      obj.AccountName.split("|")
      [obj.AccountName.split("|").length - 1].toLowerCase()
        .trim()
        .indexOf("@in4partners.com") !== -1)
  ) {
    isPartner = true;
  }
  // const testEmail = "ulyana.ibraeva@napitkivmeste.ru";
  // const testId = 16420;
  // const testAccount = prefix + testEmail;
  const current = {
    accountName: obj.AccountName,
    displayName: `${displayName}${persNumber && " (" + persNumber + ")"}`,
    fullName: `${displayName}`,
    fullNameWithPatronymic: fullNameWithPatronymic,
    email: obj.AccountName.split("|")[obj.AccountName.split("|").length - 1].toLowerCase().trim(),
    originalEmail: obj.Email && obj.Email.toLowerCase().trim(),
    id: obj.Id,
    avatar: obj.PictureUrl,
    shortName: shortName,
    persNumber: persNumber,
    isAdmin,
    isSecurityAdmin,
    isSecurityEditor,
    incidentAdmin,
    groups: obj.Groups,
    jobTitle: `<span title="${jobTitle}">${(jobTitle.length > 20 && `${jobTitle.slice(0, 20)}...`) || `${jobTitle}`
      }</span>`,
    jobTitleStr: jobTitle,
    department: department,
    peers: obj.Peers,
    managers: obj.ExtendedManagers,
    reports: obj.DirectReports,
    isDirecor,
    isFactoryAdmin:
      (obj.Roles && obj.Roles.length > 0 && obj.Roles.some((elem: any) => elem.Role === "FactoryAdmin")),
    hasFactoryAdminRole:
      (obj.Roles && obj.Roles.length > 0 && obj.Roles.some((elem: any) => elem.Role === "FactoryAdmin")) || false,
    isLocationEditorMyTasks:
      (obj.Roles &&
        obj.Roles.length > 0 &&
        obj.Roles.filter((elem: any) => elem.Role === "CollectionEditor").length > 0 &&
        obj.Roles.filter((elem: any) => elem.Role === "CollectionEditor" && elem.LocationMyTasks).map(
          (elem: any) => elem.LocationMyTasks.ID,
        ).filter((id: any) => {
          if (!isAdmin) {
            return id !== 61 // Регион в МЗ
          } else {
            return id
          }
        })) ||
      false,
    isLocationAdminMyTasks:
      (obj.Roles &&
        obj.Roles.length > 0 &&
        obj.Roles.filter((elem: any) => elem.Role === "CollectionAdmin").length > 0 &&
        obj.Roles.filter((elem: any) => elem.Role === "CollectionAdmin" && elem.LocationMyTasks).map(
          (elem: any) => elem.LocationMyTasks.ID,
        ).filter((id: any) => {
          if (!isAdmin) {
            return id !== 61 // Регион в МЗ
          } else {
            return id
          }
        })) ||
      false,
    isCollectionEditor:
      (!isPartner &&
        obj.Roles &&
        obj.Roles.length > 0 &&
        obj.Roles.filter((elem: any) => elem.Role === "CollectionEditor").length > 0 &&
        obj.Roles.filter((elem: any) => elem.Role === "CollectionEditor" && elem.Collection).map(
          (elem: any) => elem.Collection.ID,
        )) ||
      false,
    isCollectionAdmin:
      (!isPartner &&
        obj.Roles &&
        obj.Roles.length > 0 &&
        obj.Roles.filter((elem: any) => elem.Role === "CollectionAdmin").length > 0 &&
        obj.Roles.filter((elem: any) => elem.Role === "CollectionAdmin" && elem.Collection).map(
          (elem: any) => elem.Collection.ID,
        )) ||
      false,
    infoVPO,
    infoGOS,
  };
  addAnalysis(current, null, null, "isVisit", "");
  console.log("currentUser: ", current);
  return current;
});
